import { allApplyQueryUrl,allApplyRevokeUrl,allApplyBackupUrl } from 'Utils/urlUtil'
import { get, post } from 'Utils/apiUtil'
import util from 'Utils/commonUtil'

export const ALL_APPLY_LIST = 'ALL_APPLY_LIST';
export const ALL_APPLY_LIST_DETAILS = 'ALL_APPLY_LIST_DETAILS';
export const ALL_APPLY_BACKUP_ITEM = 'ALL_APPLY_BACKUP_ITEM';
export const ALL_APPLY_TAB_ACTIVE = 'ALL_APPLY_TAB_ACTIVE';
export const ALL_APPLY_SEARCH_FIELD = 'ALL_APPLY_SEARCH_FIELD';
export const ALL_APPLY_REVOKE_ITEM = 'ALL_APPLY_REVOKE_ITEM';
export const ALL_APPLY_MORE_INITIAL = 'ALL_APPLY_MORE_INITIAL';
export const ALL_APPLY_MORE_FAILURE = 'ALL_APPLY_MORE_FAILURE';

// Get More all apply
export const getMoreAllApplyList = data => dispatch => dispatch(post(allApplyQueryUrl, data))
    .then(res => {
        dispatch({ type: ALL_APPLY_LIST, payload: res });
        return res;
    });


//view
export const viewAllApplyList = (id) => (dispatch) => {
    dispatch({type: ALL_APPLY_LIST_DETAILS, payload: {}});
    return dispatch(get(`${allApplyRevokeUrl}/${id}`)).then((res) => {
        dispatch({type: ALL_APPLY_LIST_DETAILS, payload: res.data});
        return res;
    });
};

// backup
export const backupAllApplyItem = (id) => (dispatch) => {
    dispatch({type: ALL_APPLY_BACKUP_ITEM, payload: {}});
    return dispatch(get(`${allApplyBackupUrl}?id=${id}`)).then((res) => {
        dispatch({type: ALL_APPLY_BACKUP_ITEM, payload: res.data});
        return res;
    });
};

// Update F1 Order Tab Active
export const updateAllApplyTabActive = params => ({ type: ALL_APPLY_TAB_ACTIVE, payload: params });

// querykey
export const updateAllApplyListSearchFields = params => ({ type: ALL_APPLY_SEARCH_FIELD, payload: params });

